export interface FeatureToggles {
  utilizeCVR: boolean;
  utilizeNemhandel: boolean;
  utilizeWikiLinks: boolean;
  utilizeBankHolidayCalendar: boolean;
  utilizeKlarpris: boolean;
  utilizeAddressSearch: boolean;
}

export const FEATURE_TOGGLE_DEFAULTS: FeatureToggles = {
  utilizeCVR: true,
  utilizeNemhandel: true,
  utilizeWikiLinks: true,
  utilizeBankHolidayCalendar: true,
  utilizeKlarpris: true,
  utilizeAddressSearch: true
};
